import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { TabItem } from 'src/app/core/interfaces/tab-item.interface';
import { TabRoutesService } from 'src/app/core/services/tab-routes.service';

@Component({
  selector: 'app-scafold-container',
  templateUrl: './scafold-container.component.html',
  styleUrl: './scafold-container.component.scss'
})
export class ScafoldContainerComponent implements OnInit, OnDestroy {
  items: TabItem[] = []

  private destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.tabRouteService.tabRotues$
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        this.items = res;
      });
  }

  constructor(private tabRouteService: TabRoutesService) { }
}
